import { useState, useEffect, useRef } from 'react';
import { Icon } from '@iconify/react';
import closeFill from '@iconify/icons-eva/close-fill';
import { useTranslation } from 'react-i18next';
// material
import { Box, Backdrop, Paper, Tooltip, Divider, Typography, Stack, Avatar, Grid, IconButtonm, Popover, TextField, Button, LinearProgress, Card, Accordion, AccordionSummary, AccordionDetails, CardMedia } from '@material-ui/core';
//
import { MIconButton } from '../@material-extend';
import Lottie from 'react-lottie';
import callingGif from './gifLottie/calling.json'
import IncomingCall from './IncomingCall';
import OutgoingCall from './OutgoingCall';
import CounterUp from './TimeCalling';
import './css/CircularButton.css';
import { useSelector } from '../../redux/store';
import MenuPopover from '../MenuPopover';
import { ContentPasteSearchOutlined } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandDialPadDtmf from './ExpandDialPadDtmf';
import apiContact from '../../api/contact';
import apiUser from '../../api/user';
import FormActionContact2 from '../../pages/ActionContact/FormActionContact2';
import useAuth from '../../hooks/useAuth';
import Scrollbar from '../Scrollbar';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import CastConnectedIcon from '@mui/icons-material/CastConnected';
import { useSnackbar } from 'notistack5';
// ----------------------------------------------------------------------
import CallEndIcon from '@mui/icons-material/CallEnd';
import EmptyContent from '../EmptyContent';
import ConnectVideo from '../ConnectVideo';
import MicOffIcon from '@mui/icons-material/MicOff';
import ScreenShareIcon from '@mui/icons-material/ScreenShare';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import VideocamIcon from '@mui/icons-material/Videocam';
const DRAWER_WIDTH = 1600;

export default function VideoCalling() {
  const { enqueueSnackbar } = useSnackbar();
  const { videoCalling, doVideoCall, incomingVideoCall, doAnswer, doHangup, msgError, doCloseCall, toggleMute, isMuted, is_share_screen, doShareScreen, toggleVideo,isMutedVideo,infoContact } = useSelector(state => state.janusVideo);
  console.log(incomingVideoCall)
  const {user} = useAuth()
  const [open, setOpen] = useState(true);
  const [isScreenSharing, setIsScreenSharing] = useState(false);
  const [stream, setStream] = useState(null);
  const [screenShareStream, setScreenShareStream] = useState(null);
  const localVideoref = useRef();
  useEffect(() => {
    //const get_info =  apiUser.findone_user()
  }, []);
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: callingGif,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };
  const startScreenShare = async () => {
    try {
      const screenStream = await navigator.mediaDevices.getDisplayMedia();
      localVideoref.current.srcObject = screenStream;
      localVideoref.current.muted = true;
      setIsScreenSharing(true);
    } catch (error) {
      console.error('Error accessing screen share:', error);
    }
  };
  useEffect(() => {
    if (msgError) {
      enqueueSnackbar(msgError, { variant: 'error' });
      doCloseCall()
    }
  }, [msgError]);
  const test = () => {
    doVideoCall("test")
  }
  return (
    <>

      {/* <Backdrop sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open} onClick={handleClose} /> */}

      <Box
        sx={{
          top: 12,
          bottom: 12,
          right: 0,
          position: 'fixed',
          zIndex: 2002,
          ...(open && { right: 12 })
        }}
      >
        <Box
          sx={{
            p: 0.5,
            px: '4px',
            mt: 0,
            left: -44,
            top: '40%',
            color: 'grey.800',
            position: 'absolute',
            bgcolor: 'common.white',
            borderRadius: '24px 0 16px 24px',
            boxShadow: (theme) => theme.customShadows.z12
          }}
        >
          <Tooltip title="Calling">
            <MIconButton
              color="inherit"
              //onClick={handleToggle}
              sx={{
                p: 0,
                width: 40,
                height: 40,
                transition: (theme) => theme.transitions.create('all'),
                '&:hover': { color: 'primary.main', bgcolor: 'transparent' }
              }}
            >
              <Lottie options={defaultOptions}
                height={40}
                width={40} />
            </MIconButton>
          </Tooltip>
        </Box>
        <Paper
          sx={{
            // height: 1,
            // width: '0px',
            width: '100%', height: "100%",
            overflow: 'hidden',
            boxShadow: (theme) => theme.customShadows.z24,
            transition: (theme) => theme.transitions.create('width'),
            ...(open && { width: incomingVideoCall ? 'auto' : DRAWER_WIDTH, height: incomingVideoCall ? "12%" : "100%" }),
            backgroundColor: "#01102e",
            //backgroundImage: 'url(https://api-multichannel.voip24h.vn/public/images/popup-dialing.svg)',
            // backgroundSize: 'cover', // or 'contain'
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ py: 1, pr: 1, pl: 2.5 }}>
            <MIconButton >
              <Icon icon={closeFill} width={20} height={20} />
            </MIconButton>
            <Stack>
              <Typography sx={{ color: "white" }}>
                {incomingVideoCall ? "Đang có cuộc gọi đến" : ""}
              </Typography>

            </Stack>
          </Stack>
          <Divider />
          {incomingVideoCall && <Stack sx={{ p: 1 }} direction={"row"} justifyContent={"space-between"} spacing={2}>
            <Stack direction="row" alignItems="center">
              <Avatar src="TEST" sx={{ width: 40, height: 40 }} />
              <Typography variant="subtitle2" sx={{ ml: 1 }} color="white" noWrap>
                {infoContact?.full_name}
              </Typography>
              {/* <Button onClick={() => doAnswer()}>Trả lời </Button>
              <Button onClick={() => doHangup()}>Kết thúc </Button> */}
            </Stack>
            <Stack direction={"row"} justifyContent={"flex-end"} spacing={2}>
              <MIconButton
                color="inherit"
                onClick={() => doAnswer()}
                sx={{
                  backgroundColor: "#16e208",
                  transition: (theme) => theme.transitions.create('all'),
                  '&:hover': { color: 'primary.main', bgcolor: 'transparent' }
                }}
              >
                < LocalPhoneIcon
                  sx={{ color: "white", }}
                />
              </MIconButton>
              <MIconButton
                color="inherit"
                onClick={() => doHangup()}
                sx={{
                  backgroundColor: "#ee3c38",
                  transition: (theme) => theme.transitions.create('all'),
                  '&:hover': { color: 'primary.main', bgcolor: 'transparent' }
                }}
              >
                < CallEndIcon
                  sx={{ color: "white", }}
                />
              </MIconButton>
            </Stack>


          </Stack>}
          {!incomingVideoCall &&
            <Box sx={{ p: 2, width: '100%', height: "100%", display: "flex", gap: 2 }}>
              <Box maxWidth={100} display={"block"} sx={{ p: 1, background: "#5646447a", zIndex: 999, borderRadius: '5px', bottom: "22%", left: 24 }} position="absolute">
                <Typography noWrap color="white" variant='subtitle2'> {infoContact?.full_name} </Typography>
              </Box>
              <Box sx={{ width: '100%', height: "100%", display: "flex", gap: 2, flexDirection: "column" }}>

                <Card id="videoright" sx={{ display: "block", width: '100%', height: '70vh', background: "#212b36" }} >
                  <Stack id="is_connect_video_right" flexDirection={"column"} overflow={"hidden"} sx={{ flexGrow: 1, height: "100%" }}>
                    <EmptyContent

                      title="Connecting Video...."
                      img="/static/illustrations/illustration_empty_calling3.svg"
                      sx={{ flexGrow: 1, height: 'auto' }}
                    />
                  </Stack>
                  {/* <CardMedia id="peervideo" src='https://media.istockphoto.com/id/1455772765/vi/video/th%C3%A1c-n%C6%B0%E1%BB%9Bc-v%E1%BB%9Bi-l%C3%A0n-n%C6%B0%E1%BB%9Bc-ng%E1%BB%8Dt-trong-khu-r%E1%BB%ABng-nhi%E1%BB%87t-%C4%91%E1%BB%9Bi-nhi%E1%BB%87t-%C4%91%E1%BB%9Bi-l%C3%A3ng-m%E1%BA%A1n-v%C3%A0-b%C3%ACnh-d%E1%BB%8B-v%C6%B0%E1%BB%9Dn-qu%E1%BB%91c.mp4?s=mp4-640x640-is&k=20&c=4n7Bf8Xx_mySen62asVoLRqtDMZtBFSc3QlSYs1OE30=' sx={{ width: "100%", height: "100%", display: "none" }} component={'video'} autoPlay> </CardMedia>
                 */}
                </Card>

                <Stack direction={"row"} justifyContent={"center"} spacing={2} >
                  <MIconButton
                    color="inherit"
                    onClick={toggleMute}
                    sx={{
                      backgroundColor: "#1e2938",
                      transition: (theme) => theme.transitions.create('all'),
                      '&:hover': { color: 'primary.main', bgcolor: 'transparent' }
                    }}
                  >
                    {!isMuted ?
                      < KeyboardVoiceIcon
                        sx={{ color: "white", }}
                      /> :
                      <MicOffIcon
                        sx={{ color: "white", }}
                      />}
                  </MIconButton>
                  <MIconButton
                    color="inherit"
                    onClick={toggleVideo}
                    sx={{
                      backgroundColor: "#1e2938",
                      transition: (theme) => theme.transitions.create('all'),
                      '&:hover': { color: 'primary.main', bgcolor: 'transparent' }
                    }}
                  >
                    {!isMutedVideo ?
                      < VideocamIcon
                        sx={{ color: "white", }}
                      /> :
                      <VideocamOffIcon
                        sx={{ color: "white", }}
                      />}
                  </MIconButton>

                  <MIconButton
                    color="inherit"
                    onClick={doHangup}
                    sx={{
                      backgroundColor: "#ee3c38",
                      transition: (theme) => theme.transitions.create('all'),
                      '&:hover': { color: 'primary.main', bgcolor: 'transparent' }
                    }}
                  >
                    < LocalPhoneIcon
                      sx={{ color: "white", }}
                    />
                  </MIconButton>

                  <MIconButton
                    color="inherit"
                    onClick={() => doShareScreen(!is_share_screen)}
                    sx={{
                      backgroundColor: "#1e2938",

                      transition: (theme) => theme.transitions.create('all'),
                      '&:hover': { color: 'primary.main', bgcolor: 'transparent' }
                    }}
                  >
                    < ScreenShareIcon
                      sx={{ color: "white", }}
                    />
                  </MIconButton>

                </Stack>
              </Box>

              <Card sx={{ display: "block", width: '40%', height: '74.4%', background: "#172845", p: 2, }} >
                <Grid container spacing={2} height={"100%"}>
                  <Grid item xs={12} md={12} height={"100%"}>
                    <Card id="videoleft" sx={{ display: "block", boxShadow: '4px 4px 8px 0 currentColor', flex: "100%", height: "100%", background: "#212b36" }} >
                      <Box maxWidth={100} display={"block"} sx={{ p: 1, background: "#5646447a", zIndex: 999, borderRadius: '5px', bottom: 0, left: 0 }} position="absolute">
                        <Typography noWrap color="white" variant='subtitle2'> {user?.full_name} </Typography>
                      </Box>
                      {/* <Stack id="is_connect_video_left" flexDirection={"column"} overflow={"hidden"} sx={{ flexGrow: 1, height: "100%" }}>
                        <ConnectVideo
                          title="Connecting Video..."
                          img="/static/illustrations/illustration_empty_calling.svg"
                          sx={{ flexGrow: 1, height: '100%' }}
                        />
                      </Stack> */}
                      <CardMedia id="myvideo" src='https://www.w3schools.com/tags/movie.mp4' sx={{ width: "100%", height: "100%", display: "block" }} component={'video'} autoPlay> </CardMedia>
                    </Card>
                  </Grid>
                 

                </Grid>
              </Card>
            </Box>
          }
        </Paper>
      </Box >
    </>
  );
}
